import ListingModal from './listing-modal-container'

export default ListingModal
